<template>
  <v-col v-if="!wrapper.hide" class="pt-0 pb-2" cols="12">

    <v-row no-gutters align="center">
      <v-col cols="auto" class="d-flex align-center mr-2">
        <v-icon v-text="wrapper.icon" size="18"></v-icon>
      </v-col>
      <v-col cols="auto">
        {{ wrapper.tag }}
      </v-col>
      <v-col cols="0" class="d-flex align-center mx-3">
        <v-progress-linear v-if="wrapper.loading" indeterminate :color="'tertiary'" height="3">
        </v-progress-linear>
        <v-divider v-else />
      </v-col>
    </v-row>
    <v-container v-if="wrapper.loading">
      Searching...
    </v-container>
    <v-container v-else-if="wrapper.error" class="error--text">
      {{ wrapper.error && (wrapper.error.code != "ERR_CANCELED") ? 'Error fetching results' : 'Search canceled' }}
    </v-container>
    <v-container v-else-if="!wrapper.list[0]">
      No results
    </v-container>
    <v-container v-else class="pa-0" fluid>
      <v-row no-gutters>
        <v-col>
          <template v-for="(element) in wrapper.list.slice(0, maxLinesPerWrapper)">
            <SearchItemWrapper :key="wrapper.tag + '-' + element.Id" :wrapper="wrapper" :item="element">
            </SearchItemWrapper>
          </template>

          <v-btn :color="'blue'" text small class="px-4"
            :to="!wrapper.onViewAll ? { name: 'SearchResults', query: { filter: wrapper.tag, q: query } } : undefined"
            @click="wrapper.onViewAll(query)">View all<v-icon size="18">mdi-chevron-right</v-icon>
          </v-btn>

        </v-col>
        <template v-if="wrapper.maximize">
          <v-col>
            <template v-for="(element) in wrapper.list.slice(5, 10)">
              <SearchItemWrapper :key="wrapper.tag + '-' + element.Id" :wrapper="wrapper" :item="element">
              </SearchItemWrapper>
            </template>
            <v-btn v-if="wrapper.list.length > 5 && wrapper.list.length < 10" color="primary" text small
              :to="{ name: 'SearchResults' }">Full search <v-icon size="18">mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <template v-for="(element) in wrapper.list.slice(10, 14)">
              <SearchItemWrapper :key="wrapper.tag + '-' + element.Id" :wrapper="wrapper" :item="element">
              </SearchItemWrapper>
            </template>
            <v-btn v-if="wrapper.list.length > 14" color="primary" text :to="{ name: 'SearchResults' }">Full search
              <v-icon size="18">mdi-chevron-right</v-icon>
            </v-btn>
            <v-list-item dense>
              view all
            </v-list-item>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-col>
</template>


<script>
import SearchItemWrapper from "@/components/Sections/AppSections/SearchItemWrapper.vue";

export default {
  name: "SearchResultWrapperList",
  props: {
    query: String,
    wrapper: Object,
    activeWrapperCount: Number,
  },
  components: {
    SearchItemWrapper,
  },
  mixins: [],

  data() {
    return {};
  },

  mounted() { },

  methods: {
  },

  computed: {
    maxLinesPerWrapper() {
      if (this.activeWrapperCount > 2) {
        return 5;
      } else if (this.activeWrapperCount > 1) {
        return 7;
      } else {
        return 15;
      }
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>